import ApiService from './_api.service'
import { Demand as Model } from '@/models/demand.model'

const API_DEMANDS_URL = '/v1/demands/'

const DemandService = {
    create: function(entity) {
        let data = new FormData()
        Object.keys(Model.createFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.post(API_DEMANDS_URL, data)
    },

    readListDemands: async function(args) {
        const url = API_DEMANDS_URL + 'list/'

        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }

        return ApiService.get(url + queryParams)
    },

    readDemands: async function(args) {
        const url = API_DEMANDS_URL

        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }

        return ApiService.get(url + queryParams)
    },

    updateIntervalDemand: async function(id, quantity) {
        return ApiService.put(API_DEMANDS_URL + id + '/', {
            quantity: quantity
        })
    },

    updateDateNapDemand: async function(args) {
        return ApiService.put(API_DEMANDS_URL + args.demand_id, {
            ids: args.demand_ids,
            datetime_nap: args.datetime_nap
        })
    },

    update: async function({ demand_id, ...data }) {
        return ApiService.put(API_DEMANDS_URL + demand_id, data)
    }
}

export default DemandService
export { DemandService }
